// Traducciones para vehículos - Español
export const vehiclesEs = {
  // Página de vehículos
  page: {
    title: 'Vehículos',
    found: 'vehículos encontrados',
    searchPlaceholder: 'Buscar por marca, modelo o año...',
    noResults: 'No se encontraron vehículos',
    noResultsDescription: 'Intenta ajustar los filtros o criterios de búsqueda',
    orderBy: 'Ordenar por',
    showMore: 'Ver más',
  },

  // Detalles del vehículo
  details: {
    loading: 'Cargando detalles del vehículo...',
    notFound: 'Vehículo no encontrado',
    backToVehicles: 'Volver a vehículos',
    specifications: 'Especificaciones',
    features: 'Características',
    contact: 'Contactar por este vehículo',
    description: 'Descripción',
  },

  // Filtros
  filters: {
    title: 'Filtros',
    clearFilters: 'Limpiar filtros',
    applyFilters: 'Aplicar filtros',
    close: 'Cerrar filtros',
    showMore: 'Ver más',
    showLess: 'Ver menos',
    priceRange: 'Rango de precio',
    minPrice: 'Precio mínimo',
    maxPrice: 'Precio máximo',
    selectBrand: 'Selecciona una marca',
    brand: 'Marca',
    model: 'Modelo',
    category: 'Categoría',
    year: 'Año',
    fuelType: 'Tipo de combustible',
    condition: 'Condición',
    color: 'Color',
    mileage: 'Kilometraje',
    dealership: 'Sucursal',
    facturable: 'Facturable',
    facturableYes: 'Con factura',
    facturableNo: 'Sin factura',
    facturableHint:
      'Los vehículos con factura se venden afectos a IVA, así la empresa puede usar el crédito fiscal.',
    transmission: 'Transmisión',
    transmissionManual: 'Manual',
    transmissionAutomatic: 'Automática',
    traction: 'Tracción',
    traction4x2: '4x2',
    traction4x4: '4x4',
    tractionAwd: 'AWD (integral)',
    tractionFwd: 'FWD (delantera)',
  },

  // Categorías
  categories: {
    all: 'Todos los Vehículos',
    suv: 'SUV',
    sedan: 'Sedán',
    hatchback: 'Hatchback',
    pickup: 'Pickup',
    camioneta: 'Camioneta',
    van: 'Van',
    coupe: 'Coupé',
    wagon: 'Wagon',
    trabajo: 'Vehículos de trabajo',
  },
  categoryDescriptions: {
    all: 'Explora todos nuestros vehículos disponibles',
    suv: 'Vehículos espaciosos y versátiles',
    sedan: 'Autos familiares cómodos',
    hatchback: 'Compactos y eficientes',
    pickup: 'Vehículos de carga y trabajo',
    camioneta: 'Camionetas de trabajo y doble cabina',
    van: 'Vehículos espaciosos para pasajeros',
    coupe: 'Elegantes y deportivos',
    wagon: 'Vehículos familiares versátiles',
    trabajo: 'Camionetas y vehículos para faena',
  },

  // Ordenamiento
  sorting: {
    dateDesc: 'Recientes primero',
    dateAsc: 'Antiguos primero',
    priceAsc: 'Precio: Menor a Mayor',
    priceDesc: 'Precio: Mayor a Menor',
    yearDesc: 'Año: Más Reciente',
    yearAsc: 'Año: Más Antiguo',
    mileageAsc: 'Kilometraje: Menor a Mayor',
    mileageDesc: 'Kilometraje: Mayor a Menor',
  },

  // Card de vehículo
  card: {
    year: 'Año',
    mileage: 'Kilometraje',
    price: 'Precio',
    viewDetails: 'Ver detalles',
    contact: 'Contactar',
    reserved: 'Reservado',
    sold: 'Vendido',
    features: 'Características',
    fuel: 'Combustible',
    transmission: 'Transmisión',
    color: 'Color',
  },

  // Estados
  status: {
    available: 'Disponible',
    reserved: 'Reservado',
    sold: 'Vendido',
    pending: 'Pendiente',
  },
};

